export enum ValueChangeColorScheme {
    Irrelevant,
    IncreaseGoodDecreaseBad,
    IncreaseBadDecreaseGood,
}
